import { Box, Button, Grid, InputAdornment, Stack, TextField } from "@mui/material";
import { useState } from "react";
// import { UserAndConversations } from 'src/models/userAndConversations';

import SearchIcon from "@mui/icons-material/Search";
import { PureLightThemeCaaS } from "src/theme/schemes/PureLightTheme";

function TextFieldHelp({ searchText, setSearchText, label = "Search" }) {
    const handleSearchTextChange = (event) => {
        setSearchText(event.target.value);
    };

    return (
        <Grid container justifyContent="center" spacing={2} pt={1.5} pb={1}>
            <Grid item xs={12}>
                <Box bgcolor="#EDEDED">
                    <Stack direction={{ xs: "row", lg: "row" }} justifyContent={{ xs: "center", lg: "center" }} alignItems="center">
                        <TextField
                            id="outlined-basic"
                            label={label}
                            variant="outlined"
                            color="info"
                            autoComplete="off"
                            value={searchText}
                            onChange={handleSearchTextChange}
                            InputProps={{
                                endAdornment: <SearchIcon sx={{ pt: 0.2 }} />,
                                style: { color: PureLightThemeCaaS.colors.alpha.black[100], backgroundColor: "#EDEDED", height: "36px", paddingLeft: "10px", paddingBottom: "5px" },
                            }}
                            InputLabelProps={{
                                style: {
                                    color: PureLightThemeCaaS.colors.alpha.black[100],
                                    backgroundColor: "#EDEDED",
                                },
                            }}
                            sx={{
                                width: "300px",
                                "& .MuiInputBase-root": {
                                    height: "36px",
                                },
                                "& .MuiInputLabel-outlined": {
                                    // Vertically center label in 36px field (9px from top centers ~18px line)
                                    transform: "translate(14px, 9px) scale(1)",
                                    "&.MuiInputLabel-shrink": {
                                        transform: "translate(20px, -9px) scale(0.75)",
                                    },
                                },
                                // Black border default, focused, and hover
                                "& .MuiOutlinedInput-root": {
                                    "& fieldset": {
                                        borderColor: PureLightThemeCaaS.colors.alpha.black[100],
                                    },
                                    "&:hover fieldset": {
                                        borderColor: PureLightThemeCaaS.colors.alpha.black[100],
                                    },
                                    "&.Mui-focused fieldset": {
                                        borderColor: PureLightThemeCaaS.colors.alpha.black[100],
                                        borderWidth: "1px",
                                    },
                                },
                            }}
                        />
                    </Stack>
                </Box>
            </Grid>
        </Grid>
    );
}

export default TextFieldHelp;
